<template>
  <a-modal :visible="true" title="添加日程" @ok="sub" @cancel="cancel">
    <a-form
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="项目">
        <a-input type="text" v-model="addModal.title"></a-input>
      </a-form-item>
      <a-form-item label="贝展时间">
        <a-date-picker v-model="addModal.date" />
        <br />
        <a-time-picker
          v-model="addModal.start_time"
          format="HH:mm"
          :minuteStep="10"
          placeholder="开始时间"
        />
        <span style="margin: 0 5px">-</span>
        <a-time-picker
          v-model="addModal.end_time"
          placeholder="结束时间"
          format="HH:mm"
          :minuteStep="10"
        />
      </a-form-item>
      <a-form-item label="场地">
        <a-input type="text" v-model="addModal.place"></a-input>
      </a-form-item>
      <a-form-item label="备注">
        <a-textarea
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="addModal.remarks"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style lang='scss' scoped>
</style>

<script>
import moment from "moment";
export default {
  props: ["exh_id"],
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 19,
        },
      },
      addModal: {
        exh_id: null,
        title: "",
        place: "",
        date: null,
        start_time: null,
        end_time: null,
        remarks: "",
      },
    };
  },
  created() {
    this.addModal.exh_id = this.exh_id;
  },
  methods: {
    moment,
    async sub() {
      this.addModal.exh_id = this.exh_id;
      if (!this.addModal.date) return this.$message.error("请选择日期");
      if (!this.addModal.start_time)
        return this.$message.error("请选择开始时间");
      if (!this.addModal.end_time) return this.$message.error("请选择结束时间");

      const r = await this.$axios.post("/exh/calendar/create", this.addModal);

      if (r.status == 1) {
        this.callback(true);
      }
    },

    cancel() {
      this.callback(false);
    },

    callback(e) {
      this.$emit("callback", e);
    },
  },
};
</script>